import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { injectIntl } from "react-intl"
import "./loader.css"

const useStyles = makeStyles(theme => {
  return {
    root: {
      height: "100vh",
      width: "40vh",
      margin: "0 auto",
      position: "relative",
      [theme.breakpoints.down('md')]: {
        display: "none",
      }
    },
    rootSub: {
      width: "100%",
      height: "100vh",
      margin: "0 auto",
      position: "absolute",
    },
    spinner: {
      margin: 0,
      position: "absolute",
      top: "50%",
      left: "50%",
      "-ms-transform": "translate(-50%, -50%)",
      transform: "translate(-50%, -50%)",
    },
    ldsRing: {
      display: "inline-block",
      position: "absolute",
      width: "64px",
      height: "64px",
      top: "50%",
      left: "50%",
      "-ms-transform": "translate(-50%, -50%)",
      transform: "translate(-50%, -50%)",
      "& div": {
        "box-sizing": "border-box",
        display: "block",
        position: "absolute",
        width: "51px",
        height: "51px",
        margin: "6px",
        border: "6px solid #fff",
        "border-radius": "50%",
        animation: "lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite",
        "border-color": "rgba(0, 0, 0, 0.87) transparent transparent transparent",
      },
      "& div:nth-child(1)": {
        "animation-delay": "-0.45s",
      },
      "& div:nth-child(2)": {
        "animation-delay": "-0.3s",
      },
      "& div:nth-child(3)": {
        "animation-delay": "-0.15s",
      },
    },
  }
})

export default injectIntl(props => {
  const classes = useStyles()

  return (
    <div className={props.isFull ? classes.rootSub : classes.root}>
      <div className={classes.ldsRing}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )

})
